import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/parking/space/log/page', Object.assign({}, options, {
    params
  }));
